import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=28be5dd7&scoped=true&"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordForm.vue?vue&type=style&index=0&id=28be5dd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28be5dd7",
  null
  
)

export default component.exports